import type {
    GetDistrictsResponseType,
    GetDistrictsRequestType
} from "./type";
import {
    request
} from "../request";

const getDistricts = async (
    params: GetDistrictsRequestType
): Promise<GetDistrictsResponseType> => {
    return await request<GetDistrictsResponseType>(`/staticData/getDistricts?cityID=${params.cityID}`, {
        method: "GET"
    });
};

export default getDistricts;
